import { render, staticRenderFns } from "./PromotionalCarousel.vue?vue&type=template&id=349c5ee8&scoped=true"
import script from "./PromotionalCarousel.vue?vue&type=script&lang=js"
export * from "./PromotionalCarousel.vue?vue&type=script&lang=js"
import style0 from "./PromotionalCarousel.vue?vue&type=style&index=0&id=349c5ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349c5ee8",
  null
  
)

export default component.exports